import SharedDropZoneFileUpload from '../file-upload';

export default class SharedDropZoneMobileFileUpload extends SharedDropZoneFileUpload {}
